module.exports = "<div class=\"text-center bell\">\n    <h1><i class=\"fa fa-bell\"></i></h1>\n    <h5>No new notifications.</h5>\n</div>"